import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFireCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.15 7.93092C15.15 7.93092 14.1203 3.4872 10.3046 1.51685C10.1949 1.46018 10.0665 1.55489 10.0787 1.67516C10.2597 3.45625 8.68769 5.20456 7.45026 6.5808C7.04179 7.03509 6.66977 7.44883 6.40929 7.80983C5.22195 9.1003 4.5 10.8043 4.5 12.6723C4.5 14.7665 5.40734 16.6545 6.86053 17.9848L11.1515 22.1582C11.6201 22.6139 12.3799 22.6139 12.8485 22.1582L17.1392 17.9851C18.5925 16.6548 19.5 14.7666 19.5 12.6723C19.5 12.1727 19.4484 11.6848 19.35 11.2134C19.35 11.2134 18.5889 7.10644 16.2598 4.57708C16.1661 4.47538 15.9966 4.55073 16.0022 4.68713C16.0814 6.5934 15.404 7.60926 15.2044 7.86547L15.15 7.93092Z",
		fill: "#E25345"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 11.9045L15.06 11L10.6667 15.1975L8.94667 13.5605L8 14.4586L10.6667 17L16 11.9045Z",
		fill: "white"
	})]
});
export default SvgFireCheck;
